import axios from 'axios'
import router from '@/router';
import route from '@/router';
import { formatDateToYMD } from '@/utils/dateFormatter'
import api from '@/api';

export const сorporateOrdersProductsModule = {
    namespaced: true,

    state:() => ({
        shops: null,
        categories: null,
        products: null,
        cart: {
            items: [],
            shop_code: null,
            productCounts: 0,
            totalPrice: 0,
        },
        orderCreated: false,
        pages: null,
        counteragents: null,
        counteragents_modal_loading: true,
        default_shop: 0,
    }),

    mutations: {
        setShops(state, data) {
            for(let i = 0; i < data.length; i++) {
                data[i].label = data[i].name
                data[i].value = data[i].id
            }

            state.shops = data
        },

        setCategories(state, data) {
            for(let i = 0; i < data.length; i++) {
                data[i].label = data[i].real_name
                data[i].value = data[i].id
                data[i].checked = true
            }

            state.categories = data
        },

        setProducts(state, data) {
            for(let i = 0; i < data.length; i++) {
                data[i].quantity = 0
            }
            state.products = data
        },

        setPages(state, data) {
            state.pages = data
        },

        setCounteragents(state, data) {
            state.counteragents = data
            state.counteragents_modal_loading = false
        }
    },

    actions: {
        getShops({ commit }) {
            axios
            .get(api + "projects/tcode/shops/", {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                commit('setShops', response.data)
                // console.log(response)
            })
            .catch((error) => {
                console.log(error);
            });
        },

        getCategories({ state, commit }) {
            const shop_code = route.currentRoute.value.query.shop_code
            const project_code = state.shops.find(x => x.code == shop_code).project_code

            axios
            .get(`${api}projects/${project_code}/shops/${shop_code}/categories/?available=for_corporate`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                commit('setCategories', response.data.results)
                console.log(response.data.results)
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        getProducts({ state, rootState, commit, dispatch }) {
            rootState.isLoading = true

            if(router.currentRoute.value.fullPath.split('?')[1]) {
                const shop_code = route.currentRoute.value.query.shop_code
                const project_code = state.shops.find(x => x.code == shop_code).project_code

                if(state.cart.shop_code !== shop_code) {
                    dispatch('orderClear')
                }
                state.cart.shop_code = shop_code

                axios
                .get(`${api}projects/${project_code}/shops/${shop_code}/products?${router.currentRoute.value.fullPath.split('?')[1]}&available=for_corporate`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    commit('setProducts', response.data.results)
                    commit('setPages', response.data.num_pages)

                    rootState.isLoading = false
                })
                .catch((error) => {
                    console.log(error.response);
                });
            }
        },

        inputProductCount({ state, dispatch }, data) {
            if(data.type === 'plus') {
                const product = { ...state.products.find(product => product.id === data.id) }

                const elem = state.cart.items.find(item => item.id === product.id)
                if(elem) {
                    elem.quantity ++
                    
                    localStorage.setItem('corporate_cart', JSON.stringify(state.cart))
                } else {
                    product.quantity++
                    state.cart.items.push(product)

                    localStorage.setItem('corporate_cart', JSON.stringify(state.cart))
                }
                
                dispatch('calculatePrice')
            } else if (data.type === 'minus') {
                for(let i = 0; i < state.cart.items.length; i++) {
                    if(state.cart.items[i].id === data.id && state.cart.items[i].quantity > 0) {
                        state.cart.items[i].quantity --
                        if(state.cart.items[i].quantity < 1) {
                            state.cart.items.splice(i, 1)
                        }

                        localStorage.setItem('corporate_cart', JSON.stringify(state.cart))
                    }
                }

                dispatch('calculatePrice')
            } else if (data.type === 'manual') {
                const product = { ...state.products.find(product => product.id === data.id) }
                const elem = state.cart.items.find(item => item.id === product.id)

                if(elem) {
                    if(data.value > 0) {
                        elem.quantity = data.value
                    } else {
                        for(let i = 0; i < state.cart.items.length; i++) {
                            if(state.cart.items[i].id === data.id ) {
                                state.cart.items.splice(i, 1)
                            }
                        }
                    }
                    
                    localStorage.setItem('corporate_cart', JSON.stringify(state.cart))
                } else {
                    product.quantity = data.value
                    state.cart.items.push(product)

                    localStorage.setItem('corporate_cart', JSON.stringify(state.cart))
                }

                dispatch('calculatePrice')
            } else {
                for(let i = 0; i < state.cart.items.length; i++) {
                    if(state.cart.items[i].id === data.id) {    
                        state.cart.items.splice(i, 1)
                    }

                    localStorage.setItem('corporate_cart', JSON.stringify(state.cart))
                }
                dispatch('calculatePrice')
            }
        },

        calculatePrice({ state }) {
            state.cart.totalPrice = 0
            state.cart.productCounts = 0

            for(let i = 0; i < state.cart.items.length; i++) {
                if(state.cart.items[i].quantity > 0) {
                    state.cart.totalPrice += state.cart.items[i].quantity * state.cart.items[i].price_float.toFixed(2)
                    state.cart.productCounts ++
                }
            }
        },

        sendOrder({ state, dispatch }, data) {
            const shop_code = route.currentRoute.value.query.shop_code;
            const shop = state.shops?.find(x => x.code === shop_code);
            if (!shop) {
                alert('Не удалось определить проект для магазина');
                return;
            }
            const project_code = shop.project_code;

            // Форматирование времени
            const pad = n => String(n).padStart(2, '0');
            const time = `${pad(data.order_time.hours)}:${pad(data.order_time.minutes)}`;

            // Форматирование даты
            let dateStr = '';
            if (typeof data.order_date === 'string') {
                dateStr = data.order_date;
            } else if (data.order_date instanceof Date && !isNaN(data.order_date)) {
                dateStr = formatDateToYMD(data.order_date);
            } else {
                alert('Некорректная дата заказа');
                return;
            }

            // Формируем объект заказа
            const order = {
                items: state.cart.items,
                delivery_date: `${dateStr} ${time}`,
                editable_order: !!data.editable,
                comment: data.comment || '',
                chopsticks: data.chopsticks || 1,
                name: data.name || '',
                phone: data.phone || '',
                counteragent: data.counteragent?.id ?? null,
                discount_amount: data.discount_amount ?? 0,
                additional_price: data.additional_price ?? 0,
                prepayment_amount: data.prepayment_amount ?? 0,
                tables: data.tables ?? null
            };

            // Проверка на пустую корзину
            if (!order.items || !order.items.length) {
                alert('Корзина пуста');
                return;
            }
                        
            axios.post(
                `${api}projects/${project_code}/shops/${shop_code}/personal/orders/`,
                order,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                }
            )
            .then((response) => {
                if (response.data.created) {
                    dispatch('orderClear');
                    dispatch('changeOrderStatus', true);
                } else {
                    dispatch('orderClear');
                    alert(response.data);
                }
            })
            .catch((error) => {
                console.error(error?.response || error);
                alert('Ошибка при отправке заказа');
            });
        },

        fetchCart({ state, dispatch }) {
            const cart = JSON.parse(localStorage.getItem('corporate_cart')) ?? null
            
            if(cart) {
                state.cart = cart
            }

            dispatch('calculatePrice')
        },  

        orderClear({ state }) {
            state.cart.productCounts = 0
            state.cart.totalPrice = 0
            state.cart.date = null
            state.cart.items = []

            localStorage.removeItem('corporate_cart')
        },

        changeOrderStatus({ state }, status) {
            state.orderCreated = status
        },

        async productEdit({ state, dispatch }, data) {
            const shop_code = route.currentRoute.value.query.shop_code
            const project_code = state.shops.find(x => x.code == shop_code).project_code

            try {
                const response = await axios.patch(`${api}projects/${project_code}/shops/${shop_code}/products/${data.id}?available=for_corporate`,
                data.data,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                dispatch('getProducts')
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },

        async fetchCounteragents({ state, commit }) {
            state.counteragents_modal_loading = true
            try {
                const response = await axios.get(`${api}projects/tcode/counteragents/`,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                commit('setCounteragents', response.data)
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        }
        // async addNewProduct({ dispatch }, data) {
        //     try {
        //         const response = await axios.post("https://admin.tcode.online/api/projects/tubatay-production/shops/production/products/",
        //         data,
        //         {
        //             headers: {
        //                 Authorization: 'Token ' + localStorage.getItem('token')
        //             }
        //         })
        //         dispatch('getProducts')
        //     } catch(err) { // Если есть ошибка
        //         console.log(err)
        //     }
        // },

        // async productDelete({ dispatch }, id) {
        //     try {
        //         const response = await axios.delete(`https://admin.tcode.online/api/projects/tubatay-production/shops/production/products/${id}/`,
        //         {
        //             headers: {
        //                 Authorization: 'Token ' + localStorage.getItem('token')
        //             }
        //         })

        //         console.log(response)
        //     } catch(err) { // Если есть ошибка
        //         console.log(err)
        //     }
        // }
    }
}